import {bus} from '../lib/eventBus.js';

export function installGlobals(app) {
  // Запрещает скролл страницы и компенсирует ширину полосы прокрутки,
  // чтобы визуально не было дерганий в интерфейсе
  app.config.globalProperties.toggleNoScroll = (noScroll)=>{
    if (noScroll) {
      document.body.style.paddingRight = `${window.innerWidth - document.body.clientWidth}px`;
      document.body.classList.add('no-scroll');
      return;
    }
    document.body.classList.remove('no-scroll');
    document.body.style.paddingRight = '';
  };

  // Шина глобальных событий. ИСПОЛЬЗОВАТЬ ТОЛЬКО В КРАЙНЕМ СЛУЧАЕ
  // Для обмена событиями между не связанными компонентами
  app.config.globalProperties.$bus = bus;
}
